import type { ProjectStatus } from '@/utils/projectStatuses';

/** Буква в квадратике этапа (концепт project-edit-round3, 6.1.2): у «Проверки», «Правок» и «Проверки правок» одна и та же «П» — различает цвет */
export const STAGE_LETTER: Record<ProjectStatus, string> = {
  Добавлен: 'Д',
  Запись: 'З',
  Монтаж: 'М',
  Проверка: 'П',
  Правки: 'П',
  'Проверка правок': 'П',
  Готов: 'Г',
};
